import IndigoMalformedMessage from 'communication/IndigoMalformedMessage';
import { addItemToArrayWithMaxSize } from 'utils/arrays/arrayUtils';

const MAX_ERRORS = 10;

export enum StreamErrorType {
    GENERIC_STREAM_ERROR = 'GENERIC_STREAM_ERROR',
    MALFORMED_MESSAGE_ERROR = 'MALFORMED_MESSAGE_ERROR',
}

export interface StreamErrorBase<StreamErrorType, TError> {
    type: StreamErrorType;
    details: TError;
    timestamp: Date;
}

export type GenericStreamError = StreamErrorBase<
    StreamErrorType.GENERIC_STREAM_ERROR,
    Error
>;

export function genericStreamError(error: Error): GenericStreamError {
    return {
        type: StreamErrorType.GENERIC_STREAM_ERROR,
        details: error,
        timestamp: new Date(),
    };
}

export type MalformedMessageError = StreamErrorBase<
    StreamErrorType.MALFORMED_MESSAGE_ERROR,
    IndigoMalformedMessage
>;

export function malformedMessageError(
    message: IndigoMalformedMessage
): MalformedMessageError {
    return {
        type: StreamErrorType.MALFORMED_MESSAGE_ERROR,
        details: message,
        timestamp: new Date(),
    };
}

export type StreamError = GenericStreamError | MalformedMessageError;

export function reduceErrors(
    errors: StreamError[],
    error: StreamError
): StreamError[] {
    return addItemToArrayWithMaxSize(error, errors, MAX_ERRORS);
}
